import React, { Fragment, useMemo } from 'react';
import DataTable from 'react-data-table-component';
import { convertDate, convertDateTime, formatCurrency } from '../../../Library/custom_utils';
import { H6, H3 } from '../../../AbstractElements';


const tableColumns = [
    { name: 'Principal Amount', selector: row => row.fixAmount, center: true, width: '150px' },
    { name: 'Date Started', selector: row => row.fixStarted, center: true },
    { name: 'Date Ended', selector: row => row.fixEnded, center: true },
    { name: 'Total Commission', selector: row => row.amount, grow: 1 },
];

const EarnHistoryTable = ({ data, isLoading, totalRows, currentPage, onPageChange, limit }) => {
    
    const formattedData = useMemo(() => {
        return data.map((item) => ({
            fixAmount: (
                <H3 attrH3={{ className: 'f-14 mb-0 font-info font16-bold' }}>
                    {formatCurrency(item.fixAmount)}
                </H3>
            ),
            fixStarted: (
                <H6 attrH6={{ className: 'f-14 mb-0 f-light' }}>
                    {convertDate(item.fixStarted)}
                </H6>
            ),
            fixEnded: (
                <H6 attrH6={{ className: 'f-14 mb-0 f-light' }}>
                    {convertDate(item.fixFinished)}
                </H6>
            ),
            amount: (
                <H3 attrH3={{ className: 'f-14 mb-0 font-success font16-bold' }}>
                    {formatCurrency(item.amount || 0)}
                </H3>
            )
        }));
    }, [data]);
       
      return (
        <Fragment>
            {isLoading ? (
                // <MothriftLoader />
                <h3>Loading....</h3>
            ) : (
                <DataTable
                    data={formattedData}
                    columns={tableColumns}
                    striped
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationPerPage={limit}
                    paginationDefaultPage={currentPage}
                    onChangePage={onPageChange}
                    persistTableHead
                    responsive
                />
            )}
        </Fragment>
    );
};

export default EarnHistoryTable;